import { render, staticRenderFns } from "./ExternalScriptVariableGuideIframe.vue?vue&type=template&id=8927f7ea&"
import script from "./ExternalScriptVariableGuideIframe.vue?vue&type=script&lang=ts&"
export * from "./ExternalScriptVariableGuideIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports